import { AppRootState } from '../../../../../store/models/app-state.model';
import { ReviewStatisticsModel } from '../models/review-statistics.model';

export const getReviewsStatsSelector = (
  state: AppRootState
): ReviewStatisticsModel | null => state.reviews.stats;
